import { render, staticRenderFns } from "./CustomerFinder.vue?vue&type=template&id=54cf587b"
import script from "./CustomerFinder.vue?vue&type=script&lang=js"
export * from "./CustomerFinder.vue?vue&type=script&lang=js"
import style0 from "./CustomerFinder.vue?vue&type=style&index=0&id=54cf587b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports